import { useState } from 'react';

export type SnackbarType = 'success' | 'error' | 'warning' | 'info';

export function useSnackbar() {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarType, setSnackbarType] = useState<SnackbarType>('info');
  const [apiMessage, setApiMessage] = useState<string | null>(null);

  const showMessage = (message: string, type: SnackbarType = 'info') => {
    setApiMessage(message);
    setSnackbarType(type);
    setShowSnackbar(true);
  };

  return {
    showSnackbar,
    snackbarType,
    apiMessage,
    setShowSnackbar,
    showMessage,
  };
}
